import { Box, Typography } from '@mui/material';

export interface VerifyMatchTranscriptionTextProps {
  children: string;
}

/**
 * Compact transcription body with a light gray background for the verify dialog.
 */
export function VerifyMatchTranscriptionText({ children }: VerifyMatchTranscriptionTextProps) {
  return (
    <Box
      sx={{
        bgcolor: 'grey.50',
        borderRadius: 1,
        px: 1.5,
        py: 1,
      }}
    >
      <Typography
        variant="body1"
        color="text.secondary"
        component="p"
        sx={{ whiteSpace: 'pre-wrap', fontSize: 15 }}
      >
        {children}
      </Typography>
    </Box>
  );
}
